import { render, staticRenderFns } from "./OutherSide.vue?vue&type=template&id=52eef8be&scoped=true&"
import script from "./OutherSide.vue?vue&type=script&lang=js&"
export * from "./OutherSide.vue?vue&type=script&lang=js&"
import style0 from "./OutherSide.vue?vue&type=style&index=0&id=52eef8be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eef8be",
  null
  
)

export default component.exports